import { Container, Header, Modal, Segment, Icon, Transition, Button } from 'semantic-ui-react'
import { Text } from 'preact-i18n'
import { useStore } from '../../store'

const NoCameraAvailableModal = () => {
  const store = useStore()
  const open = store.errorsStore.hasNoCameraAvailableError.value && !store.singleImageModeStore.enabled.value
  return (
    <Transition visible={open} animation="scale" duration={600} unmountOnHide>
      <Modal id="no-camera-modal" basic open={true}>
        <Container textAlign="center">
          <Modal.Header>
            <Segment inverted>
              <Header icon>
                <Icon name="warning sign" size="huge" />
                <Text id="warnings.camera.notAvailable">No Camera available</Text>
              </Header>
            </Segment>
          </Modal.Header>
          <Modal.Content>
            <Segment inverted>
              <p>
                <Text id="warnings.camera.notAvailableMessage" />
              </p>
              <p>
                <Text id="warnings.camera.notAvailableButSingleImageModeMessage" />
              </p>
            </Segment>
          </Modal.Content>
          <Modal.Actions>
            <div style={{ padding: '1rem' }}>
              <Button icon color="green" inverted onClick={() => store.singleImageModeStore.enable()}>
                <Icon name="checkmark" />
                <Text id="actions.continue" />
              </Button>
            </div>
          </Modal.Actions>
        </Container>
      </Modal>
    </Transition>
  )
}
export default NoCameraAvailableModal
